
































































































































































































































































































































































import _ from 'lodash'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import ReservaDeSangueStore from '@/components/SolicitacaoCirurgia/store/ReservaDeSangueStore'
import { onlyNumber } from '@/utils/common'
import { ClassificacaoAsaEnum, TipoDocumentoUpload } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentBackofficeDadosAnestesia extends Vue {
  @Prop({ required: true }) disabled: boolean
  @Prop({ required: false, default: 'Dados da anestesia' }) title: string
  @Prop({ required: false, default: true }) showBtn: boolean
  @Prop({ required: false, default: false }) visualizacao: boolean

  get disableBtnReservaDeSangue() {
    if (this.$route.name === 'BackofficePreAnestesico') return false
    // @ts-ignore
    return !this.getBackofficeGlobalStore.solicitacao.temSolicitacaoReservaDeSangue
  }

  $refs!: {
    dadosAnestesiaForm: any,
    reservaDeSangue: any,
  }

  up: boolean = false
  loadDeleteLaudo: boolean = false

  dadosAnestesiaForm: any = {
    valid: true,
    tipoAnestesia: [v => this.validate(v, 'tipoAnestesia')],
    outrosTipoAnestesia: [v => this.validate(v, 'outrosTipoAnestesia')],
    alergiaLatex: [v => this.validate(v, 'alergiaLatex')],
    outrasAlergias: [v => this.validate(v, 'outrasAlergias')],
    especificarOutrasAlergias: [v => this.validate(v, 'especificarOutrasAlergias')],
    reservaHemocomponentes: {
      semReserva: [v => this.validate(v, 'semReserva')],
      concentradoHemacias: [v => this.validate(v, 'concentradoHemacias')],
      concentradoPlaquetas: [v => this.validate(v, 'concentradoPlaquetas')],
      crioprecipitado: [v => this.validate(v, 'crioprecipitado')],
      plasmaFrescoCongelado: [v => this.validate(v, 'plasmaFrescoCongelado')],
    },
    reservaUTI: [v => this.validate(v, 'reservaUTI')],
    viasAereasDificilAcesso: [v => this.validate(v, 'viasAereasDificilAcesso')],
    pacienteUsaMarcaPasso: [v => this.validate(v, 'pacienteUsaMarcaPasso')],
    historicoFamiliarHipertemiaMaligna: [v => this.validate(v, 'historicoFamiliarHipertemiaMaligna')],
    classificacaoAsa: [],
    pacienteAptoParaAnestesia: [v => this.validate(v, 'pacienteAptoParaAnestesia')],
    // observacaoPreAnestesia: [v => this.validate(v, 'observacaoPreAnestesia')],
    observacaoComplementares: [v => this.validate(v, 'observacaoComplementares')],
  }

  loadReservaDeSangue: boolean = false

  opcaoHabilitado(prop1: string, prop2: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop1]
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos[prop2]
      return response
    }

    return false
  }

  validate(value: any, field: string) {
    switch (field) {
      case 'tipoAnestesia':
        if ((!value || value.length <= 0) && !this.disabled) return 'Por favor, informe o tipo de anestesia'
        return true
      case 'outrosTipoAnestesia':
        if ((this.tipoAnestesia.includes('Outros') && !value) && !this.disabled) return 'Por favor, informe o outro tipo de anestesia.'
        return true
      case 'alergiaLatex':
        if ((value === undefined || value === null) && !this.disabled) return 'Por favor, informe a alergia.'
        return true
      case 'outrasAlergias':
        if ((value === undefined || value === null) && !this.disabled) return 'Por favor, informe se o paciente possui outras alergias.'
        return true
      case 'especificarOutrasAlergias':
        if ((this.outrasAlergias && !value) && !this.disabled) return 'Por favor, especifique a alergia.'
        return true
      case 'semReserva':
        return true
      case 'reservaUTI':
        if ((!value) && !this.disabled) return 'Por favor, informe a reserva de UTI.'
        return true
      case 'viasAereasDificilAcesso':
        if ((value === undefined || value === null) && !this.disabled) return 'Por favor, informe se as vias aéreas são de difícil acesso.'
        return true
      case 'pacienteUsaMarcaPasso':
        if ((value === undefined || value === null) && !this.disabled) return 'Por favor, informe se o paciente usa marca passo ou não.'
        return true
      case 'historicoFamiliarHipertemiaMaligna':
        if ((value === undefined || value === null) && !this.disabled) return 'Por favor, informe se a familia do paciente tem histórico hipertemia malígna.'
        return true
      case 'classificacaoAsa':
        if ((value === undefined || value === null) && !this.disabled) return 'Por favor, informe se a classificação ASA.'
        return true
      case 'pacienteAptoParaAnestesia':
        if ((value === undefined || value === null) && !this.disabled) return 'Por favor, informe se o paciente ou não para a anestesia.'
        return true
      case 'observacaoPreAnestesia':
        if ((!value) && !this.disabled) return 'Por favor, informe as observações pré-anestésicas'
        return true
      case 'observacaoComplementares':
        if ((!value) && !this.disabled) return 'Por favor, informe as observações complementares'
        return true
      default:
        return true
    }
  }

  get loadingReservaDeSangue() {
    return this.loadReservaDeSangue
  }

  set loadingReservaDeSangue(value: boolean) {
    this.loadReservaDeSangue = value
  }

  get tipoAnestesia() {
    return this.getBackofficeGlobalStore.solicitacao.tipoAnestesiaTemp || []
  }

  set tipoAnestesia(value: any) {
    this.getBackofficeGlobalStore.setTipoAnestesia(value)
  }

  get outrosTipoAnestesia() {
    return this.getBackofficeGlobalStore.solicitacao.outrosTipoAnestesia || ''
  }

  set outrosTipoAnestesia(value: string) {
    this.getBackofficeGlobalStore.setOutrosTipoAnestesia(value)
  }

  get alergiaLatex() {
    return this.getBackofficeGlobalStore.solicitacao.alergiaLatex
  }

  set alergiaLatex(value: number | boolean | null) {
    this.getBackofficeGlobalStore.setAlergiaLatex(value)
  }

  get outrasAlergias() {
    return this.getBackofficeGlobalStore.solicitacao.outrasAlergias
  }

  set outrasAlergias(value: boolean | null) {
    this.getBackofficeGlobalStore.setOutrasAlergias(value)
  }

  get especificarOutrasAlergias() {
    return this.getBackofficeGlobalStore.solicitacao.especificarOutrasAlergias
  }

  set especificarOutrasAlergias(value: string | null) {
    this.getBackofficeGlobalStore.setEspecificarOutrasAlergias(value)
  }

  get observacaoPreAnestesia() {
    return this.getBackofficeGlobalStore.solicitacao.observacaoPreAnestesia
  }

  set observacaoPreAnestesia(value: string | null) {
    this.getBackofficeGlobalStore.setObservacaoPreAnestesia(value)
  }

  get observacaoComplementares() {
    return this.getBackofficeGlobalStore.solicitacao.observacaoComplementares
  }

  set observacaoComplementares(value: string | null) {
    this.getBackofficeGlobalStore.setObservacaoComplementares(value)
  }

  get reservaUTI() {
    return this.getBackofficeGlobalStore.solicitacao.reservaUTI.key
  }

  set reservaUTI(value: string) {
    this.getBackofficeGlobalStore.setReservaUTI(value)
  }

  get viasAereasDificilAcesso() {
    return this.getBackofficeGlobalStore.solicitacao.viasAereasDificilAcesso
  }

  set viasAereasDificilAcesso(value: boolean | null) {
    this.getBackofficeGlobalStore.setViasAereasDificilAcesso(value)
  }

  get pacienteUsaMarcaPasso() {
    return this.getBackofficeGlobalStore.solicitacao.pacienteUsaMarcaPasso
  }

  set pacienteUsaMarcaPasso(value: boolean | null) {
    this.getBackofficeGlobalStore.setPacienteUsaMarcaPasso(value)
  }

  get historicoFamiliarHipertemiaMaligna() {
    return this.getBackofficeGlobalStore.solicitacao.historicoFamiliarHipertemiaMaligna
  }

  set historicoFamiliarHipertemiaMaligna(value: boolean | null) {
    this.getBackofficeGlobalStore.setHistoricoFamiliarHipertemia(value)
  }

  get classificacaoAsa() {
    return this.getBackofficeGlobalStore.solicitacao.classificacaoAsa
  }

  set classificacaoAsa(value: ClassificacaoAsaEnum | null) {
    this.getBackofficeGlobalStore.setClassificacaoAsa(value)
  }

  get pacienteAptoParaAnestesia() {
    return this.getBackofficeGlobalStore.solicitacao.pacienteAptoParaAnestesia
  }

  set pacienteAptoParaAnestesia(value: boolean | null) {
    this.getBackofficeGlobalStore.setPacienteAptoParaAnestesia(value)
  }

  // Limpar reserva de sangue via ref
  clearReservaDeSangue() {
    this.$refs.reservaDeSangue.clearReservaDeSangue()
  }

  formatFiltrado(value: string | null) {
    if (!value) return ''
    if (value === 'Filtrado') return 'Filtrado'
    return 'Filtrado e Irradiado'
  }

  get getLaudos() {
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      return this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.LaudoAnestesista)
    }
    return []
  }

  set getLaudos(value) {
    this.getBackofficeGlobalStore.setLaudos(value)
  }

  get uploading() {
    return this.up
  }

  set uploading(value: boolean) {
    this.up = value
  }

  get loadingDeleteLaudo() {
    return this.loadDeleteLaudo
  }

  set loadingDeleteLaudo(value: boolean) {
    this.loadDeleteLaudo = value
  }

  async showModalReservaDeSangue() {
    this.loadingReservaDeSangue = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const request = await this.getReservaSangueStore.getReservaDeSangue(solicitacaoId)

    if (!request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
      this.loadingReservaDeSangue = false
      return
    }

    this.getReservaSangueStore.setReservaDeSangueDisabled(this.$route.name !== 'BackofficePreAnestesico' || this.visualizacao)
    this.getReservaSangueStore.setShowModalReservaDeSangue(true)
    this.getReservaSangueStore.setAptoComAtencao(true)
    this.loadingReservaDeSangue = false
  }

  async deleteLaudo(value) {
    this.loadingDeleteLaudo = true
    const request = await this.getBackofficeGlobalStore.deleteLaudo({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      id: value.id,
    })

    if (request.success) {
      if (request.success) {
        const removeArray: any[] = []

        for (let i = 0; i < this.getLaudos.length; i++) {
          if (this.getLaudos[i].identifier === value.identifier) {
            removeArray.push(i)
          }
        }

        for (let i = 0; i < removeArray.length; i++) {
          this.getLaudos.splice(removeArray[i], 1)
        }
      }
    }

    this.loadingDeleteLaudo = false
  }

  async inputFileLaudo(newFile, oldFile) {
    this.uploading = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)

    const request = await this.getBackofficeGlobalStore.uploadLaudoAnestesista(form)

    // eslint-disable-next-line no-param-reassign
    newFile.identifier = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.id = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.url = request.data[0].url
    // eslint-disable-next-line no-param-reassign
    newFile.nomeOriginalArquivo = request.data[0].nomeOriginalArquivo
    // eslint-disable-next-line no-param-reassign
    newFile.tipoDocumento = TipoDocumentoUpload.LaudoAnestesista
    this.getLaudos = newFile
    this.uploading = false
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getReservaSangueStore() {
    return getModule(ReservaDeSangueStore, this.$store)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  tipoAnestesiaChange(value: string) {
    if (!this.getBackofficeGlobalStore.template.formulario.tipoAnestesia.multiSelecao) {
      if (!this.getBackofficeGlobalStore.solicitacao.tipoAnestesiaTemp.includes(value)) {
        this.getBackofficeGlobalStore.clearTipoAnestesia()
      } else {
        this.getBackofficeGlobalStore.clearTipoAnestesia()
        this.getBackofficeGlobalStore.solicitacao.tipoAnestesiaTemp.push(value)
      }
    } else if (value === 'Outros' && !this.getBackofficeGlobalStore.solicitacao.tipoAnestesiaTemp.includes(value)) {
      this.getBackofficeGlobalStore.clearOutrosTipoAnestesia()
    }
  }
}
